import React from "react";

const BareLessonContext = React.createContext(null);

export default BareLessonContext;